// extracted by css-extract-rspack-plugin
var _1 = "TB0FemCSe4tEnhFg";
export { _1 as "sliderArrow" }
// extracted by css-extract-rspack-plugin
var _1 = "TB0FemCSe4tEnhFg";
export { _1 as "sliderArrow" }
